<template>
  <b-col>
    <div class="section-footer">Back to top <i class="fas fa-arrow-up"></i></div>
    <hr>
    <div>
      <a href="#">Summary</a> | <a href="#">Full text</a> | <a href="#">Additional details</a> <br>
      See also: <a href="#">Information for decision-makers</a> <br>
      See also: <a href="#">Related systematic reviews</a> <br>
      See also: <a href="#">Messages for media</a>
    </div>
  </b-col>
</template>

<script>
export default {
  name: 'SectionFooter',
  props: {},
  data () { return {} },
  components: {}
}
</script>

<style lang="scss" scoped>
  .section-footer {
    margin-top: 2em;
  }
</style>
